"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQualityIcon = void 0;
var lodash_1 = require("lodash");
var QualityIcon_static_1 = require("./QualityIcon.static");
var QualityIcon_style_1 = __importDefault(require("./QualityIcon.style"));
function useQualityIcon(quality) {
    return {
        coloredPaths: (0, lodash_1.zipWith)(QualityIcon_static_1.qualityPaths, QualityIcon_static_1.fillColors[quality], function (path, color) { return ({ path: path, color: color }); }),
        classes: (0, QualityIcon_style_1.default)(),
    };
}
exports.useQualityIcon = useQualityIcon;
